import React from 'react'
import { TextareaView } from './TextareaView'
import { useTextarea } from './useTextarea'

interface ITextareaProps {
  value?: string | number
  label?: string
  isFixed?: boolean | false
  reference?: React.MutableRefObject<HTMLTextAreaElement>
  disabled?: boolean | false
  isFocus?: boolean | false
  isDashed?: boolean | false
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void
}
export type TextareaProps = ITextareaProps

export const Textarea = (props: TextareaProps): JSX.Element => {
  return (
    <TextareaView {...useTextarea(props)} />
  )
}
